module.exports = __webpack_public_path__ + "img/banner_en.ec938864.jpg";